import JaLayout from '@/components/feature/JaLayout';
import useSEO from '@/hooks/useSEO';
import { Link } from 'react-router-dom';

export default function JaPrivacyPolicyPage() {
  useSEO({
    title: 'プライバシーポリシー｜康永生技有限公司',
    description: '康永生技のプライバシーポリシー：個人情報の収集・利用・保管・保護に関する方針を説明します。本ウェブサイトおよび関連するすべての業務に適用されます。',
    keywords: 'プライバシーポリシー,個人情報保護,康永生技,データセキュリティ',
    lang: 'ja',
    canonicalPath: '/ja/privacy-policy',
  });

  return (
    <JaLayout>
      <div className="min-h-screen bg-white pt-24 pb-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
            <Link to="/ja" className="hover:text-gray-600 transition-colors cursor-pointer">ホーム</Link>
            <i className="ri-arrow-right-s-line text-base" />
            <span className="text-gray-600">プライバシーポリシー</span>
          </nav>

          {/* Header */}
          <div className="mb-10 pb-8 border-b border-gray-100">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">プライバシーポリシー</h1>
            <p className="text-gray-400 text-sm">最終更新日：2025年1月</p>
          </div>

          {/* Content */}
          <div className="space-y-8 text-gray-700 leading-relaxed">
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. 基本方針</h2>
              <p className="text-[0.9375rem]">
                康永生技有限公司（以下「当社」）は、お客様のプライバシーを尊重し、個人情報の保護に
                努めております。本プライバシーポリシーは、当社がどのように個人情報を収集・利用・保管・
                保護するかについて説明するものであり、本ウェブサイトおよび関連するすべての業務に適用されます。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. 収集する情報</h2>
              <p className="text-[0.9375rem] mb-3">当社は以下の情報を収集する場合があります：</p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>氏名、会社名、役職</li>
                <li>連絡先電話番号およびメールアドレス</li>
                <li>お問い合わせ内容および提携ご要望</li>
                <li>ウェブサイトの閲覧データ（Cookie等の技術情報）</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. 個人情報の利用目的</h2>
              <p className="text-[0.9375rem] mb-3">
                収集した個人情報は、以下の目的のみに使用いたします：
              </p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>お問い合わせへの返答および提携相談</li>
                <li>OEM/ODM製造に関する見積もりおよび情報提供</li>
                <li>ウェブサイトおよびサービスの改善</li>
                <li>法令に基づく必要な対応</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. 個人情報の保護</h2>
              <p className="text-[0.9375rem]">
                当社は、適切な技術的・管理的措置を講じ、お客様の個人情報を不正アクセス・
                不正利用・漏洩から保護いたします。お客様の個人情報は社内業務にのみ使用され、
                お客様の同意なしに第三者へ販売・賃貸・提供することはございません（法令上必要な場合を除く）。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Cookieの使用</h2>
              <p className="text-[0.9375rem]">
                本ウェブサイトは、閲覧体験を向上させるためにCookieおよび類似技術を使用しています。
                ブラウザの設定によりCookieを無効にすることが可能ですが、一部の機能に影響が出る場合があります。
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. お客様の権利</h2>
              <p className="text-[0.9375rem] mb-3">
                個人情報保護法に基づき、お客様は以下の権利を有します：
              </p>
              <ul className="list-disc list-inside space-y-2 text-[0.9375rem] pl-2">
                <li>個人情報の閲覧または複写の請求</li>
                <li>個人情報の補充または訂正の請求</li>
                <li>個人情報の収集・処理・利用の停止請求</li>
                <li>個人情報の削除請求</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. お問い合わせ</h2>
              <p className="text-[0.9375rem]">
                本ポリシーに関するご質問や権利行使をご希望の場合は、以下よりご連絡ください：
              </p>
              <div className="mt-4 bg-gray-50 rounded-lg p-5 space-y-2 text-[0.9375rem]">
                <p><strong className="text-gray-900">Kang Yong Biotech Ltd.（康永生技有限公司）</strong></p>
                <p className="text-gray-600">台湾 台中市北区中清路一段79号6階</p>
                <p>
                  電話：
                  <a href="tel:+886422029858" className="text-[#2d5a27] hover:underline cursor-pointer">+886-4-2202-9858</a>
                </p>
                <p>
                  メール：
                  <a href="mailto:natural1070606@gmail.com" className="text-[#2d5a27] hover:underline cursor-pointer">natural1070606@gmail.com</a>
                </p>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. ポリシーの変更</h2>
              <p className="text-[0.9375rem]">
                当社は、本プライバシーポリシーをいつでも改訂する権利を留保します。
                重要な変更がある場合は、ウェブサイト上でお知らせいたします。
                最新の内容をご確認いただくため、定期的に本ページをご参照ください。
              </p>
            </section>
          </div>

          {/* Bottom nav */}
          <div className="mt-12 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <Link
              to="/ja"
              className="inline-flex items-center gap-2 text-[#2d5a27] hover:text-[#1a3d18] text-sm font-medium transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line" />
              ホームに戻る
            </Link>
            <Link
              to="/ja/terms-of-use"
              className="inline-flex items-center gap-2 text-gray-500 hover:text-[#2d5a27] text-sm transition-colors cursor-pointer"
            >
              <i className="ri-file-text-line" />
              利用規約を見る
            </Link>
          </div>
        </div>
      </div>
    </JaLayout>
  );
}
